import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Modal } from 'antd';
import { Grid, Card } from '@material-ui/core';
import MainContainer from '../../../components/MainContainer';
import SpecialOfferList from '../../../components/AdminSpecialOffer/List';
import UpdateSpecialOfferModal from '../../../components/AdminSpecialOffer/Update/UpdateSpecialOffer';
import SearchMenuItemModal from '../../../components/AdminSpecialOffer/SearchMenuItem/SpecialOfferSearchItem';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';

@inject(
    'loginStore',
    'specialOfferStore'
)
@observer
class SpecialOfferPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        this.props.loginStore.authenticateAdmin().then(response => {
          if (!response) {
            this.props.history.push('/admin/login');
          }
        });
        
        this.props.specialOfferStore.init();
    }

    componentWillUnmount() {
        this.props.specialOfferStore.setShowUpdateSpecialOfferModal(false);
    }

    handleCancelUpdateSpecialOfferModal = () => {
        this.props.specialOfferStore.setShowUpdateSpecialOfferModal(false);
    }

    handleCancelSearchMenuIteModal = () => {
        this.props.specialOfferStore.setShowSearchMenuItemModal(false);
    }

    render() {
        const { t } = this.props;
        const {
            showUpdateSpecialOfferModal,
            showSearchMenuItemModal,
            manageSpecialOfferTitle
        } = this.props.specialOfferStore;

        return (
            <MainContainer title={t('In Room Dining Offer')} menukey='specialoffers'>
                <Modal
                    title={t(manageSpecialOfferTitle)}
                    visible={showUpdateSpecialOfferModal}
                    width={800}
                    footer={null}
                    onCancel={this.handleCancelUpdateSpecialOfferModal}
                    zIndex={1000}
                >
                    <UpdateSpecialOfferModal />
                </Modal>

                <Modal
                    title={t('Search In Room Dining')}
                    visible={showSearchMenuItemModal}
                    width={800}
                    footer={null}
                    onCancel={this.handleCancelSearchMenuIteModal}
                    zIndex={2000}
                >
                    <SearchMenuItemModal />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: "auto" }}>
                            <SpecialOfferList />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(SpecialOfferPage);